var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useToastActions } from 'common/services/toast-service/hooks';
import { useStoreActions } from 'common/store/use-store-actions';
import { useSelectedChatStore } from './service-store/service-store';
export var useSelectedChatActions = function () {
    var actions = useStoreActions(useSelectedChatStore);
    var t = useTranslation().t;
    var addSuccessToast = useToastActions().addSuccessToast;
    return useMemo(function () { return (__assign(__assign({}, actions), { leaveSelectedChat: function (chatId) {
            var _a, _b;
            var chatTitle = (_b = (_a = useSelectedChatStore.getState().content) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : '';
            actions.leaveSelectedChat(chatId);
            addSuccessToast({
                title: t('common.toast.successTitle'),
                message: t('chatPage.messagesPage.settings.leaveChat.success', { chatTitle: chatTitle }),
            });
        } })); }, [actions, addSuccessToast, t]);
};
export var useSelectChatAction = function () {
    var _a = useSelectedChatActions(), setSelectedChatId = _a.setSelectedChatId, selectChatData = _a.selectChatData;
    return useMemo(function () { return ({
        selectChatAction: function (chatId) { return setSelectedChatId(chatId); },
        selectChatDataAction: function (chat) { return selectChatData(chat); },
    }); }, [setSelectedChatId, selectChatData]);
};
